import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  LOCALE_ID,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SbbIconRegistry } from '@sbb-esta/angular/icon';
import { combineLatest, of } from 'rxjs';
import { catchError, delay, tap } from 'rxjs/operators';

@Component({
    selector: 'sbb-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {
  @ViewChild('header') header: ElementRef;
  @ViewChild('footer') footer: ElementRef;
  readonly isInIframe: boolean;
  private document: Document;

  // FPLZF-843 - for calls with this component in url, no header nor footer will be dieplayed.
  private urlsWithoutHeaderFooter: string[] = [
    '/zuege',
    '/trains', // valid for french AND english
    '/treni',
    // bvi/xxx: url for specific himMessage
    '/bvi/0', '/bvi/1', '/bvi/2', '/bvi/3', '/bvi/4', '/bvi/5', '/bvi/6', '/bvi/7', '/bvi/8', '/bvi/9'
  ];

  constructor(
    private http: HttpClient,
    private renderer: Renderer2,
    private iconRegistry: SbbIconRegistry,
    domSanitizer: DomSanitizer,
    @Inject(LOCALE_ID) private localeId,
    @Inject(DOCUMENT) document: any
  ) {
    this.document = document;
    this.isInIframe = this.checkIfInIframe();
    this.iconRegistry.addSvgIconLiteral(
      'utilization-car-avg',
      domSanitizer.bypassSecurityTrustHtml(`
<svg viewBox="0 4 16 24" xmlns="http://www.w3.org/2000/svg" class="color-immutable">
  <path fill="none" d="M0 0h16v24H0z" />
  <circle cx="4.504" cy="5.5" r="1" stroke="#000" stroke-miterlimit="10" />
  <circle cx="11.508" cy="5.5" r="1" fill="#bcbcbc" stroke="#bcbcbc" stroke-miterlimit="10" />
  <path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="3" d="M4.504 8.5V20" />
  <path fill="none" stroke="#000" stroke-miterlimit="10" d="M2.504 14V8.5h4V14" />
  <path
    fill="#bcbcbc"
    stroke="#bcbcbc"
    stroke-miterlimit="10"
    stroke-width="3"
    d="M11.5 8.5V20"
  />
  <path fill="#bcbcbc" stroke="#bcbcbc" stroke-miterlimit="10" d="M9.5 14V8.5h4V14" />
  <path
    fill="#bcbcbc"
    stroke="#bcbcbc"
    stroke-width="1.006"
    d="M9.498 8.461H13.5v4.122H9.498z"
  />
</svg>`)
    );
    this.iconRegistry.addSvgIconLiteral(
      'utilization-car1',
      domSanitizer.bypassSecurityTrustHtml(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 4 9 24">
  <path fill="none" d="M0 0h9v24H0z" />
  <circle stroke="#000" stroke-miterlimit="10" cx="4.504" cy="5.5" r="1" />
  <path fill="none" stroke="#000" stroke-width="3" stroke-miterlimit="10" d="M4.504 8.5V20" />
  <path fill="none" stroke="#000" stroke-miterlimit="10" d="M2.504 14V8.5h4V14" />
</svg>`)
    );
    this.iconRegistry.addSvgIconLiteral(
      'utilization-car2',
      domSanitizer.bypassSecurityTrustHtml(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 4 16 24">
  <path fill="none" d="M0 0h16v24H0z" />
  <circle stroke="#000" stroke-miterlimit="10" cx="4.504" cy="5.5" r="1" />
  <circle stroke="#000" stroke-miterlimit="10" cx="11.508" cy="5.5" r="1" />
  <path fill="none" stroke="#000" stroke-width="3" stroke-miterlimit="10" d="M4.504 8.5V20" />
  <path fill="none" stroke="#000" stroke-miterlimit="10" d="M2.504 14V8.5h4V14" />
  <path fill="none" stroke="#000" stroke-width="3" stroke-miterlimit="10" d="M11.5 8.5V20" />
  <path fill="none" stroke="#000" stroke-miterlimit="10" d="M9.5 14V8.5h4V14" />
</svg>`)
    );
    this.iconRegistry.addSvgIconLiteral(
      'utilization-car3',
      domSanitizer.bypassSecurityTrustHtml(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 4 23 24">
  <path fill="none" d="M0 0h23v24H0z" />
  <circle stroke="#000" stroke-miterlimit="10" cx="4.504" cy="5.5" r="1" />
  <circle stroke="#000" stroke-miterlimit="10" cx="11.508" cy="5.5" r="1" />
  <path fill="none" stroke="#000" stroke-width="3" stroke-miterlimit="10" d="M4.504 8.5V20" />
  <path fill="none" stroke="#000" stroke-miterlimit="10" d="M2.504 14V8.5h4V14" />
  <path fill="none" stroke="#000" stroke-width="3" stroke-miterlimit="10" d="M11.5 8.5V20" />
  <path fill="none" stroke="#000" stroke-miterlimit="10" d="M9.5 14V8.5h4V14" />
  <circle stroke="#000" stroke-miterlimit="10" cx="18.508" cy="5.5" r="1" />
  <path fill="none" stroke="#000" stroke-width="3" stroke-miterlimit="10" d="M18.5 8.5V20" />
  <path fill="none" stroke="#000" stroke-miterlimit="10" d="M16.5 14V8.5h4V14" />
</svg>`)
    );
    this.iconRegistry.addSvgIconLiteral(
      'utilization-car4',
      domSanitizer.bypassSecurityTrustHtml(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 4 30 24">
  <path fill="none" d="M0 0h30v24H0z" />
  <circle stroke="#000" stroke-miterlimit="10" cx="4.504" cy="5.5" r="1" />
  <circle stroke="#000" stroke-miterlimit="10" cx="11.508" cy="5.5" r="1" />
  <path fill="none" stroke="#000" stroke-width="3" stroke-miterlimit="10" d="M4.504 8.5V20" />
  <path fill="none" stroke="#000" stroke-miterlimit="10" d="M2.504 14V8.5h4V14" />
  <path fill="none" stroke="#000" stroke-width="3" stroke-miterlimit="10" d="M11.5 8.5V20" />
  <path fill="none" stroke="#000" stroke-miterlimit="10" d="M9.5 14V8.5h4V14" />
  <circle stroke="#000" stroke-miterlimit="10" cx="18.508" cy="5.5" r="1" />
  <path fill="none" stroke="#000" stroke-width="3" stroke-miterlimit="10" d="M18.5 8.5V20" />
  <path fill="none" stroke="#000" stroke-miterlimit="10" d="M16.5 14V8.5h4V14" />
  <circle stroke="#000" stroke-miterlimit="10" cx="25.508" cy="5.5" r="1" />
  <path fill="none" stroke="#000" stroke-width="3" stroke-miterlimit="10" d="M25.5 8.5V20" />
  <path fill="none" stroke="#000" stroke-miterlimit="10" d="M23.5 14V8.5h4V14" />
</svg>`)
    );
    this.iconRegistry.addSvgIconLiteral(
      'utilization-car5',
      domSanitizer.bypassSecurityTrustHtml(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 4 37 24">
      <path fill="none" d="M0 0h37v24H0z" />
      <circle stroke="#000" stroke-miterlimit="10" cx="4.5" cy="5.5" r="1" />
      <circle stroke="#000" stroke-miterlimit="10" cx="11.504" cy="5.5" r="1" />
      <circle stroke="#000" stroke-miterlimit="10" cx="18.508" cy="5.5" r="1" />
      <path fill="none" stroke="#000" stroke-width="3" stroke-miterlimit="10" d="M4.5 8.5V20" />
      <path fill="none" stroke="#000" stroke-miterlimit="10" d="M2.5 14V8.5h4V14" />
      <path fill="none" stroke="#000" stroke-width="3" stroke-miterlimit="10" d="M11.504 8.5V20" />
      <path fill="none" stroke="#000" stroke-miterlimit="10" d="M9.504 14V8.5h4V14" />
      <path fill="none" stroke="#000" stroke-width="3" stroke-miterlimit="10" d="M18.5 8.5V20" />
      <path fill="none" stroke="#000" stroke-miterlimit="10" d="M16.5 14V8.5h4V14" />
      <circle stroke="#000" stroke-miterlimit="10" cx="25.508" cy="5.5" r="1" />
      <path fill="none" stroke="#000" stroke-width="3" stroke-miterlimit="10" d="M25.5 8.5V20" />
      <path fill="none" stroke="#000" stroke-miterlimit="10" d="M23.5 14V8.5h4V14" />
      <circle stroke="#000" stroke-miterlimit="10" cx="32.508" cy="5.5" r="1" />
      <path fill="none" stroke="#000" stroke-width="3" stroke-miterlimit="10" d="M32.5 8.5V20" />
      <path fill="none" stroke="#000" stroke-miterlimit="10" d="M30.5 14V8.5h4V14" />
    </svg>`)
    );
  }

  ngOnInit(): void {
    this.document.documentElement.lang = this.localeId;
    if (this.isInIframe) {
      this.document.body.classList.add('iframe');
    }
  }

  ngAfterViewInit(): void {
    if (this.isInIframe) {
      return;
    }

    if (this.isUrlWithHeaderFooter()) {
      combineLatest([
        this.loadContentTo('header.html', this.header),
        this.loadContentTo('footer.html', this.footer)
      ])
        .pipe(delay(100))
        .subscribe(() => estatico.moduleEvents.trigger('ajaxload'));
    }
  }

  // FPLZF-843 - for calls with part of this.urlsWithoutHeaderFooter in url, no header nor footer will be dieplayed.
  private isUrlWithHeaderFooter(): boolean {
    const url  = this.document.location.href;
    const isInList = (this.urlsWithoutHeaderFooter
      .filter(part => url.indexOf(part) > 0)
      .length
      > 0);
    return ! isInList;
  }

  private checkIfInIframe() {
    try {
      return window.self !== window.top;
    } catch {
      return true;
    }
  }

  private loadContentTo(content: string, elementRef: ElementRef) {
    return this.http.get(content, { responseType: 'text' }).pipe(
      tap(c => this.assignContent(c, elementRef)),
      catchError(() => of(undefined))
    );
  }

  private assignContent(content: string, elementRef: ElementRef) {
    this.renderer.setProperty(elementRef.nativeElement, 'innerHTML', content);
  }
}
